module.exports = __webpack_public_path__ + "media/images/pc/specials/common/present_omiya_open-a54506c04df72441a7a2c7d333b23e46.png";